import React from 'react';

interface PaperTitleDisplayProps {
  title: string | null | undefined;
  subtitle?: string | null | undefined;
  className?: string;
  subtitleClassName?: string;
}

/**
 * 试卷名称 + 蓝色副标题展示组件：
 * 副标题非空时显示「名称（副标题）」，其中副标题部分（含括号）用蓝色字体；
 * 副标题为空时仅显示名称，与无副标题完全一致。
 */
export default function PaperTitleDisplay({ title, subtitle, className, subtitleClassName }: PaperTitleDisplayProps) {
  const t = (title || '').trim();
  const s = (subtitle || '').trim();
  if (!t && !s) return null;
  if (!s) return <span className={className}>{t}</span>;
  return (
    <span className={className}>
      {t}
      <span className={subtitleClassName || 'text-blue-600'}>（{s}）</span>
    </span>
  );
}

/**
 * 已拼接字符串的蓝色副标题渲染：
 * 用于读取快照字段（exam_records.paper_title / teacher_assignments.paper_title 等）
 * 的展示场景——快照存的是「名称（副标题）」完整字符串，此组件把尾部中文括号段
 * 识别出来渲染成蓝色；无尾部括号段时原样显示。
 */
export function BlueSuffixTitle({ text, subtitleClassName }: { text: string | null | undefined; subtitleClassName?: string }) {
  const raw = text || '';
  const m = raw.match(/^(.*)（([^（）]*)）$/s);
  if (!m || !m[2].trim()) return <>{raw}</>;
  return (
    <>
      {m[1]}
      <span className={subtitleClassName || 'text-blue-600'}>（{m[2]}）</span>
    </>
  );
}
